import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.9mm"
    height={14.804}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 44537 25281"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#1c1b17;stroke-width:645.463}.str1{stroke-width:491.843}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974592734144">
        <path
          d="M37332 13684H7205c-407 0-752 385-752 840v2223h31631v-2223c0-455-344-840-752-840z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 645.463,
          }}
        />
        <path
          d="M323 323v12897c0 1940 1711 3527 3804 3527h487v-2655c0-1133 826-2055 1841-2055h31627c1015 0 1841 922 1841 2055v2655h487c2092 0 3804-1587 3804-3527V323H323z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 645.463,
          }}
        />
        <path
          d="M22268 19019c-356 0-645 204-645 455v5106c0 251 289 455 645 455 357 0 646-204 646-455v-5106c0-251-289-455-646-455zM28420 19019c-356 0-645 353-645 790v4437c0 436 289 790 645 790 357 0 646-354 646-790v-4437c0-437-289-790-646-790zM16117 19019c-357 0-646 236-646 526v4964c0 290 289 526 646 526 356 0 645-236 645-526v-4964c0-290-289-526-645-526z"
          className="fill stroke1"
          style={{
            strokeWidth: 645.463,
          }}
        />
        <circle cx={3826} cy={3351} r={888} className="fill " />
        <ellipse cx={3826} cy={6579} className="fill " rx={888} ry={889} />
        <ellipse cx={3826} cy={9806} className="fill " rx={888} ry={889} />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
